import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE, formatApiError } from "../components/AuthContext";
import EngagementSignView from "../components/EngagementSignView";
import { toast } from "sonner";

// v68.51 — public engagement signing page reached from the emailed link.
export default function PublicEngagement() {
  const { token } = useParams();
  const [eng, setEng] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${API_BASE}/public/engagements/${token}`).then((r) => setEng(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [token]);

  const sign = async (body) => {
    try { const r = await axios.post(`${API_BASE}/public/engagements/${token}/sign`, body); setEng(r.data); }
    catch (e) { toast.error(formatApiError(e)); throw e; }
  };

  return (
    <div className="min-h-screen py-12 px-5" style={{ background: "var(--canvas)" }} data-testid="public-engagement-page">
      <div className="max-w-[780px] mx-auto">
        {err ? <div className="card p-10 text-center text-[var(--ink-2)]" data-testid="public-engagement-error">{err}</div>
          : !eng ? <div className="text-[var(--ink-3)]">Loading…</div>
          : <EngagementSignView eng={eng} onSign={sign} />}
      </div>
    </div>
  );
}
